export const data = [
    {
        name: 'Indoor Air Quality',
        imagelink: './images/solutions/clairco-splitimage.png',
        description: `REACH, CE and GreenPro Certified Air quality Monitors.
        The monitors measure PM2.5, PM10, CO2, CO, Temperature, Humidity and TVOC (Benzene, Toluene, Organic solvents)`
    },
    {
        name: 'Indoor Air Purification',
        imagelink: './images/solutions/filter_installed.png',
        description: `Clairco has a proprietary nano-tech based high-efficiency air filtration system for dust, gases & airborne pathogens including Sars-Cov-2`
    },
    {
        name: 'Energy Optimisation',
        imagelink: './images/solutions/Asset.png',
        description: `Clairco uses proprietary AI engine to reduce HVAC energy consumption by 25% which pays for the cost of Air Quality management achieving zero net-cost for clients`
    }
];
